export default __webpack_public_path__ + "static/github-577adf6f5bc04096e43690f780d37d71.svg";